import { render, staticRenderFns } from "./editpayment.vue?vue&type=template&id=797b6341&"
import script from "./editpayment.vue?vue&type=script&lang=js&"
export * from "./editpayment.vue?vue&type=script&lang=js&"
import style0 from "./editpayment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports